import { api } from "@/APIRequests";
import type { GoalAndObjectiveTextResponse } from "@/core/types";

export async function getGoalAndObjectiveText(
  patientId: string,
): Promise<GoalAndObjectiveTextResponse> {
  return api.carePlanTyped.get_goal_and_objective_text({
    params: { showLoader: false },
    patientId,
  });
}
